module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (119).9c59ae27.jpg";